<div class="wrapper">
	<div class="content">
		<div class="header-wrapper">
			<img routerLink="/login" queryParamsHandling="preserve" class="logo" src="./assets/logo-light.svg">
		</div>
		<div class="body-wrapper">
			<ng-content></ng-content>
		</div>
		<div class="footer-wrapper">
		</div>
	</div>	
</div>
<app-cookie-consent [force]="false"></app-cookie-consent>

